export const accessObject = (value, key) => {

  if (key?.toString().includes('.')) {
    const keys = key.split('.')
    let newVal = {...value}

    keys.forEach(k => {
      if (newVal[k]) {
        newVal = newVal[k]
      } else {
        newVal = ''
      }
    });

    return newVal
  }

  return value[key]
}

export const renderColumn = (item, columns) => {
  return columns.map((c, idx) => {
    return (c.render) ?
      // custom TD
      <td key={`column_${idx}`} className="px-2 py-2">
        {c.render(item)}
      </td>
      :
      // normal TD
      <td key={`column_${idx}`} className="px-4 py-2">

        <p className="text-sm  leading-none text-gray-600">{accessObject(item, c.key)}</p>
      </td>
  })
}